import { july4848PromoCampaign } from './july-48-48-promo';
import { resolveActivePromoCampaignFromList } from './resolve-active-promo-campaign';
import { summer2026PromoCampaign } from './summer-2026';
import type { ActivePromoCampaign, PromoCampaignContext, RegisteredPromoCampaign } from './types';

export { resolveActivePromoCampaignFromList } from './resolve-active-promo-campaign';

export const PROMO_CAMPAIGNS: RegisteredPromoCampaign[] = [july4848PromoCampaign, summer2026PromoCampaign];

export function resolveActivePromoCampaign(ctx: PromoCampaignContext): ActivePromoCampaign | null {
  return resolveActivePromoCampaignFromList(PROMO_CAMPAIGNS, ctx);
}
